<template>
	<form class="">
			<div class="flex items-center gap-x-3">

				<ui-button
					class="py-2 mt-1"
					:disabled="disabled || form.processing"
					v-on:click="submitForm()"
					:label="!subscription.invoice_sent_at ? 'Rechnung wurde versendet' : 'Rechungsversand zurücknehmen'"
				/>
			</div>
	</form>
		</template>
<script>
import axios from "axios";
import Vue from "vue";
export default {
	props: {
		subscription: {
			type: Object,
			required: true,
		},
		paymentMethodCode: {
			type: String,
			required: true,
		},
	},
	data() {
		const formData = {
			invoice_sent_at: !this.subscription.invoice_sent_at,
		};

		return {
			form: Vue.observable(this.$inertia.form(formData)),
		};
	},
	computed: {
		disabled() {

			if(this.subscription.deleted_at){
				return true;
			}

			if(this.paymentMethodCode === 'dummy'){
				return true;
			}

			const excludeStatus = ['ACTIVE', 'TRIAL'];
			if(this.paymentMethodCode === 'invoice' &&
				excludeStatus.includes(this.subscription.status)
			){
				return true;
			}
		}
	},
	methods: {
		async submitForm() {
			const params = {};
			if (this.subscription) {
				params["id"] = this.subscription.id;
			}

			console.log(this.form);

			let promise = new Promise((resolve, reject) => {
				const response = axios.post(
					this.$route("admin.subscriptions.invoice_sent", params),
					this.form
				);

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			window.location.reload();
		},
		onError(error) {

			console.log(error);

			if (error.response?.status) {
					const errors = error.response.data.errors;
					this.$bus.$emit("form:invalid", errors);
			}
		},
	},
};
</script>
